import React from 'react';

const Refresh = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_3209_62979)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M29.1975 16.5558C28.8418 13.9962 27.6544 11.6244 25.8181 9.80601C23.9818 7.98759 21.5986 6.82335 19.0356 6.49264C16.4726 6.16193 13.8719 6.68308 11.6342 7.97583C9.39649 9.26858 7.64589 11.2612 6.65208 13.6467M5.9248 7.82856V13.6467H11.743",
      stroke: "#00FFFF",
      strokeWidth: "2.61818",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.9248 19.4651C6.28053 22.0248 7.46798 24.3965 9.30424 26.2149C11.1405 28.0333 13.5237 29.1976 16.0867 29.5283C18.6498 29.859 21.2504 29.3378 23.4881 28.0451C25.7259 26.7523 27.4764 24.7597 28.4703 22.3742M29.1975 28.1924V22.3742H23.3794",
      stroke: "#00FFFF",
      strokeWidth: "2.61818",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_3209_62979" }, /* @__PURE__ */ React.createElement(
    "rect",
    {
      width: "34.9091",
      height: "34.9091",
      fill: "white",
      transform: "translate(0.106445 0.555908)"
    }
  )))
);

export { Refresh };
//# sourceMappingURL=Refresh.js.map
